import { createSelector } from "reselect";

import modalTypes from "../../enums/modalTypes";

export const getOpenModalType = (state) => state.modal.type;

export const isDrawerModalOpen = createSelector(
  getOpenModalType,
  (type) => type === modalTypes.RIGHT_DRAWER
);
